/*
 * The shell's only breakpoint. Stylesheets cannot import it (var() is not
 * valid inside a media query), so they repeat the literal and
 * breakpoints.test.ts fails if any stylesheet under layouts/, features/ or
 * shared-features/ drifts from it.
 * 767.98px, not 768px, so it never overlaps a min-width: 768px rule at
 * fractional widths. Range syntax (width < 768px) needs Safari 16.4+.
 */
export const NARROW_VIEWPORT_QUERY = "(max-width: 767.98px)";
/*
 * The exact complement of NARROW_VIEWPORT_QUERY: every width matches one of
 * the two and none matches both. For desktop-up rules, e.g. in Hero.css.
 */
export const WIDE_VIEWPORT_QUERY = "(min-width: 768px)";
